import { useFormik } from "formik";
import { Button, Grid, TextField } from "src/components";
import { useAppDispatch, useAppSelector } from "src/store";
import * as yup from "yup";
import { translate } from 'src/i18n/tHelper';
import HastalikTanimSlice from "src/store/Slices/GenelTanimlar/HastalikTanimSlice";
import VwHbsHataliktanimtaniDTO from "src/models/HastalikTanim/VwHbsHataliktanimtaniDTO";
import TarifeAutoComplete from "src/parts/Tarife/tarife.autocomplete";
import { useHastalikTanimTaniEkleMutation, useHastalikTanimTaniGuncelleMutation } from "src/services/HastalikTanim/HastalikTanimApi";

interface IHastalikTaniFormProps { };
const path = 'pages|hataliktanim';
const HastalikTaniForm = (props: IHastalikTaniFormProps): JSX.Element => {
    const hastalikTanimtaniAcitveRow = useAppSelector(s=> s.hastalikTanim.hastalikTanimtaniAcitveRow);
    const hastalikTanimActiveRow = useAppSelector(s=> s.hastalikTanim.hastalikTanimActiveRow);

    const [ekle, ekleState] = useHastalikTanimTaniEkleMutation();
    const [guncelle, guncelleState] = useHastalikTanimTaniGuncelleMutation();

    const dispatch = useAppDispatch();

    const formik = useFormik({
        initialValues: hastalikTanimtaniAcitveRow.id ? hastalikTanimtaniAcitveRow : new VwHbsHataliktanimtaniDTO(),
        onSubmit: (values) => {
            if(values.id)
            {
                guncelle(values)
                .unwrap()
                .then(closeHandler)
                .catch(err => err)
            }
            else
            {
                values.hastaliktanimId = hastalikTanimActiveRow.id;
                ekle(values)
                .unwrap()
                .then((val) => {
                    dispatch(HastalikTanimSlice.actions.setHastalikTanimtaniAcitveRow(val));
                    closeHandler();
                })
                .catch(err => err)
            }
        },
        validationSchema: yup.object({
            icdaralik: yup.string().required(translate(path, "Zorunlu Alan")),
            icdaciklama: yup.string().required(translate(path, "Zorunlu Alan")),
            ucretTarifetanimId: yup.number().required(translate(path, "Zorunlu Alan"))
        }),
    })

    const closeHandler = () => {
        dispatch(HastalikTanimSlice.actions.setFetchParam(2));
        dispatch(HastalikTanimSlice.actions.setDialogParam(0));
    }

    return (
        <>
            <Grid container>
                <Grid item md={12}>
                    <TextField 
                        name="icdaralik"
                        label={translate(path,"ICD Aralık")}
                        value={formik.values.icdaralik}
                        onChange={formik.handleChange}
                        // helperText={formik.errors.adi}
                        error={formik.errors.icdaralik?.length > 0}                        
                    />
                </Grid>
                <Grid item md={12}>
                    <TextField 
                        name="icdaciklama"
                        label={translate(path,"ICD Açıklama")}
                        value={formik.values.icdaciklama}
                        onChange={formik.handleChange}
                        // helperText={formik.errors.adi}
                        error={formik.errors.icdaciklama?.length > 0}                        
                    />
                </Grid>
                <Grid item md={12}>
                    <TarifeAutoComplete 
                        name = "ucretTarifetanimId"
                        label={translate(path,"Tarife")}
                        value = {formik.values.ucretTarifetanimId}
                        onChange= {formik.handleChange}
                        error={formik.errors.ucretTarifetanimId?.length > 0}                                                
                    />
                </Grid>
                <Grid item md={6}>
                    <Button 
                        customType="save"
                        onClick={() => formik.submitForm()}
                        loading ={ekleState.isLoading || guncelleState.isLoading}
                    />
                </Grid>                
                <Grid item md={6}>
                    <Button 
                        customType="cancel"
                        onClick={() => dispatch(HastalikTanimSlice.actions.setDialogParam(0))}
                    />
                </Grid>                
            </Grid>
        </>
    );
};

export default HastalikTaniForm;